/**
 * DefaultModelBadge: marks the team's default deployed model (TRA-1215),
 * the one the nightly evals score. Rendered wherever a model is named
 * with its status, so the flag reads the same on the list and the page.
 */

import { Badge } from '@/components/ui/badge'

export function DefaultModelBadge(): React.JSX.Element {
  return (
    <Badge variant="outline" title="The nightly evals score this model">
      Default
    </Badge>
  )
}
